const moneyFormatters = new Map();

function formatMoney(amountMinor, currency = "BRL") {
  const key = `${currency}:pt-BR`;
  if (!moneyFormatters.has(key)) {
    moneyFormatters.set(
      key,
      new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency,
      })
    );
  }
  return moneyFormatters.get(key).format(Number(amountMinor) / 100);
}

function lowestPricedVariant(variants = []) {
  return variants.reduce(
    (lowest, variant) =>
      !lowest || Number(variant.amountMinor) < Number(lowest.amountMinor)
        ? variant
        : lowest,
    null
  );
}

function productAvailability(variants = []) {
  if (variants.some((variant) => variant.stockStatus === "in_stock")) {
    return { label: "Em estoque", tone: "available" };
  }
  if (variants.some((variant) => variant.stockStatus === "backorder")) {
    return { label: "Disponível sob encomenda", tone: "backorder" };
  }
  return { label: "Indisponível", tone: "unavailable" };
}

export default function ProductCard({ product, storeSlug }) {
  const pricedVariant = lowestPricedVariant(product.variants);
  const availability = productAvailability(product.variants);
  const image = product.primaryImage || product.images?.[0]?.url;
  const category = product.categories?.[0]?.name;

  return (
    <article className="product-card">
      <a
        className="product-card__link"
        href={`/commerce/${encodeURIComponent(
          storeSlug
        )}/products/${encodeURIComponent(product.handle)}`}
      >
        <div className="product-card__media">
          {image ? (
            <img
              src={image}
              alt={product.images?.[0]?.altText || product.title}
              loading="lazy"
              decoding="async"
            />
          ) : (
            <div className="product-card__placeholder" aria-hidden>
              <svg viewBox="0 0 24 24" role="img">
                <path d="M4 5.5A1.5 1.5 0 0 1 5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-13Zm1.5 0v9.65l3.1-3.1a1.5 1.5 0 0 1 2.12 0l1.28 1.28 2.78-2.78a1.5 1.5 0 0 1 2.12 0l1.6 1.6V5.5h-13Zm13 8.77-2.66-2.66-4.9 4.9a.75.75 0 0 1-1.06 0l-.22-.22-2.21 2.21H18.5v-4.23ZM8 9a1.25 1.25 0 1 1 2.5 0A1.25 1.25 0 0 1 8 9Z" />
              </svg>
            </div>
          )}
        </div>

        <div className="product-card__body">
          {category && <p className="product-card__category">{category}</p>}
          <h2>{product.title}</h2>
          {product.brand && (
            <p className="product-card__brand">{product.brand}</p>
          )}

          <div className="product-card__footer">
            <div>
              {pricedVariant ? (
                <>
                  <p className="product-card__price">
                    {formatMoney(
                      pricedVariant.amountMinor,
                      pricedVariant.currency
                    )}
                  </p>
                  {pricedVariant.compareAtAmountMinor != null &&
                    Number(pricedVariant.compareAtAmountMinor) >
                      Number(pricedVariant.amountMinor) && (
                      <p className="product-card__compare-price">
                        {formatMoney(
                          pricedVariant.compareAtAmountMinor,
                          pricedVariant.currency
                        )}
                      </p>
                    )}
                </>
              ) : (
                <p className="product-card__price">Consulte</p>
              )}
            </div>
            <span
              className={`stock-badge stock-badge--${availability.tone}`}
            >
              {availability.label}
            </span>
          </div>
        </div>
      </a>
    </article>
  );
}
